import { mat4, vec3, quat } from 'gl-matrix';
import { Texture } from '../texture';

export class Decal {
  readonly modelMatrix = mat4.create();
  readonly inverseModelMatrix = mat4.create();
  opacity: number;
  /** Opacity lost per second. 0 = permanent. */
  decayRate: number;

  constructor(
    public position: vec3,
    public rotation: quat,
    public size: vec3,
    public texture: Texture,
    options?: { opacity?: number; decayRate?: number },
  ) {
    this.opacity = options?.opacity ?? 1;
    this.decayRate = options?.decayRate ?? 0;
    this.updateMatrices();
  }

  updateMatrices(): void {
    mat4.fromRotationTranslationScale(this.modelMatrix, this.rotation, this.position, this.size);
    mat4.invert(this.inverseModelMatrix, this.modelMatrix);
  }

  /** Returns true if the decal is still alive. */
  tick(dt: number): boolean {
    if (this.decayRate > 0) {
      this.opacity -= this.decayRate * dt;
      if (this.opacity <= 0) {
        this.opacity = 0;
        return false;
      }
    }
    return true;
  }
}
